/**
 * P3-PROPOSAL — Arial (Liberation Sans metric-compatible) CID->GID maps,
 * auto-generated from the rebuilt subsets; DO NOT EDIT.
 * 2026-10-22: the previous subsets extracted from the brand-standards PDF were
 * HOLLOW (7/107 glyphs with outlines) — every glyph drew empty. Rebuilt from
 * Liberation Sans (metric-compatible with Arial, libre license).
 */

export const ARIAL_GIDS: Record<'regular' | 'medium' | 'bold', Record<string, number>> = {
  "regular": {
    "32": 3,
    "33": 4,
    "34": 5,
    "35": 6,
    "36": 7,
    "37": 8,
    "38": 9,
    "39": 10,
    "40": 11,
    "41": 12,
    "42": 13,
    "43": 14,
    "44": 15,
    "45": 16,
    "46": 17,
    "47": 18,
    "48": 19,
    "49": 20,
    "50": 21,
    "51": 22,
    "52": 23,
    "53": 24,
    "54": 25,
    "55": 26,
    "56": 27,
    "57": 28,
    "58": 29,
    "59": 30,
    "60": 31,
    "61": 32,
    "62": 33,
    "63": 34,
    "64": 35,
    "65": 36,
    "66": 37,
    "67": 38,
    "68": 39,
    "69": 40,
    "70": 41,
    "71": 42,
    "72": 43,
    "73": 44,
    "74": 45,
    "75": 46,
    "76": 47,
    "77": 48,
    "78": 49,
    "79": 50,
    "80": 51,
    "81": 52,
    "82": 53,
    "83": 54,
    "84": 55,
    "85": 56,
    "86": 57,
    "87": 58,
    "88": 59,
    "89": 60,
    "90": 61,
    "91": 62,
    "92": 63,
    "93": 64,
    "94": 65,
    "95": 66,
    "96": 67,
    "97": 68,
    "98": 69,
    "99": 70,
    "100": 71,
    "101": 72,
    "102": 73,
    "103": 74,
    "104": 75,
    "105": 76,
    "106": 77,
    "107": 78,
    "108": 79,
    "109": 80,
    "110": 81,
    "111": 82,
    "112": 83,
    "113": 84,
    "114": 85,
    "115": 86,
    "116": 87,
    "117": 88,
    "118": 89,
    "119": 90,
    "120": 91,
    "121": 92,
    "122": 93,
    "123": 94,
    "124": 95,
    "125": 96,
    "126": 97
  },
  "medium": {
    "32": 3,
    "33": 4,
    "34": 5,
    "35": 6,
    "36": 7,
    "37": 8,
    "38": 9,
    "39": 10,
    "40": 11,
    "41": 12,
    "42": 13,
    "43": 14,
    "44": 15,
    "45": 16,
    "46": 17,
    "47": 18,
    "48": 19,
    "49": 20,
    "50": 21,
    "51": 22,
    "52": 23,
    "53": 24,
    "54": 25,
    "55": 26,
    "56": 27,
    "57": 28,
    "58": 29,
    "59": 30,
    "60": 31,
    "61": 32,
    "62": 33,
    "63": 34,
    "64": 35,
    "65": 36,
    "66": 37,
    "67": 38,
    "68": 39,
    "69": 40,
    "70": 41,
    "71": 42,
    "72": 43,
    "73": 44,
    "74": 45,
    "75": 46,
    "76": 47,
    "77": 48,
    "78": 49,
    "79": 50,
    "80": 51,
    "81": 52,
    "82": 53,
    "83": 54,
    "84": 55,
    "85": 56,
    "86": 57,
    "87": 58,
    "88": 59,
    "89": 60,
    "90": 61,
    "91": 62,
    "92": 63,
    "93": 64,
    "94": 65,
    "95": 66,
    "96": 67,
    "97": 68,
    "98": 69,
    "99": 70,
    "100": 71,
    "101": 72,
    "102": 73,
    "103": 74,
    "104": 75,
    "105": 76,
    "106": 77,
    "107": 78,
    "108": 79,
    "109": 80,
    "110": 81,
    "111": 82,
    "112": 83,
    "113": 84,
    "114": 85,
    "115": 86,
    "116": 87,
    "117": 88,
    "118": 89,
    "119": 90,
    "120": 91,
    "121": 92,
    "122": 93,
    "123": 94,
    "124": 95,
    "125": 96,
    "126": 97
  },
  "bold": {
    "32": 3,
    "33": 4,
    "34": 5,
    "35": 6,
    "36": 7,
    "37": 8,
    "38": 9,
    "39": 10,
    "40": 11,
    "41": 12,
    "42": 13,
    "43": 14,
    "44": 15,
    "45": 16,
    "46": 17,
    "47": 18,
    "48": 19,
    "49": 20,
    "50": 21,
    "51": 22,
    "52": 23,
    "53": 24,
    "54": 25,
    "55": 26,
    "56": 27,
    "57": 28,
    "58": 29,
    "59": 30,
    "60": 31,
    "61": 32,
    "62": 33,
    "63": 34,
    "64": 35,
    "65": 36,
    "66": 37,
    "67": 38,
    "68": 39,
    "69": 40,
    "70": 41,
    "71": 42,
    "72": 43,
    "73": 44,
    "74": 45,
    "75": 46,
    "76": 47,
    "77": 48,
    "78": 49,
    "79": 50,
    "80": 51,
    "81": 52,
    "82": 53,
    "83": 54,
    "84": 55,
    "85": 56,
    "86": 57,
    "87": 58,
    "88": 59,
    "89": 60,
    "90": 61,
    "91": 62,
    "92": 63,
    "93": 64,
    "94": 65,
    "95": 66,
    "96": 67,
    "97": 68,
    "98": 69,
    "99": 70,
    "100": 71,
    "101": 72,
    "102": 73,
    "103": 74,
    "104": 75,
    "105": 76,
    "106": 77,
    "107": 78,
    "108": 79,
    "109": 80,
    "110": 81,
    "111": 82,
    "112": 83,
    "113": 84,
    "114": 85,
    "115": 86,
    "116": 87,
    "117": 88,
    "118": 89,
    "119": 90,
    "120": 91,
    "121": 92,
    "122": 93,
    "123": 94,
    "124": 95,
    "125": 96,
    "126": 97
  },
};
